import { Component, computed, inject, input, signal } from '@angular/core'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { MatIcon } from '@angular/material/icon'
import { ActiveFilterDisplay } from 'src/app/shared/services/filter/common'
import { FilterService } from 'src/app/shared/services/filter/filter.service'
import { switchMap, combineLatest } from 'rxjs'

@Component({
  imports: [MatIcon],
  selector: 'app-active-filter-list',
  styles: `
    ul {
      min-height: 3rem;
      margin-bottom: 0.5rem;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      align-items: end;
      gap: 0.5rem;
      padding: 0;
    }
  
    li.filter-item {
      display: flex;
      gap: 0.25rem;
      min-height: 1.25rem;
      line-height: 1.25rem;
      border-radius: 0.5rem;
      border: none;
      background: gainsboro;
      padding: 0 0.5rem;
      font-style: italic;
    }
    
    li.no-filters {
      opacity: 0.5;
      font-weight: bold;
      padding-left: 5px;
    }

    button {
      margin: 0;
      padding: 0;
      border: 0;
      background: none;
    }

    .icon {
      max-height: 1.25rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0;
      margin: 0;
    }
  `,
  template: `
    <ul>
      @if (activeFilterDisplays().length === 0) {
        <li class='no-filters'>
          No filters selected
        </li>
      } @else {
        @for (i of activeFilterDisplays(); track $index) {
          <li class='filter-item'>
            <span>{{ i.headerName }}&nbsp;{{ i.operation }}&nbsp;{{ i.value }}</span>
            @if(allowRemove() && !i.constant) {
              <button (click)="i.remove()">
                <mat-icon class="icon" svgIcon="close" />
              </button>
            }
          </li>
        }
      }
    </ul>
  `,
})
export class ActiveFilterListComponent {
  private readonly filterService = inject(FilterService)

  readonly filterGroup = input.required<string>()
  readonly filterName = input<string | readonly string[] | undefined>()
  readonly allowRemove = input(true)

  protected readonly activeFilterDisplays = signal<ActiveFilterDisplay[]>([])

  protected readonly fields = computed((): readonly string[] => {
    const filterName = this.filterName()
    if (Array.isArray(filterName)) {
      return filterName
    } else if (typeof filterName === 'string') {
      return [filterName]
    } else {
      return []
    }
  })

  constructor() {
    combineLatest([toObservable(this.filterGroup), toObservable(this.fields)])
      .pipe(
        switchMap(([group, fields]) =>
          this.filterService.asActiveDisplay(group, fields),
        ),
        takeUntilDestroyed(),
      ).subscribe(activeFilterDisplays => {
        this.activeFilterDisplays.set(activeFilterDisplays)
      })
  }
}
